// extracted by mini-css-extract-plugin
export default {"burger-checkbox":"Burger_burger-checkbox__7cLKc","burger":"Burger_burger__9sXHT","burger-container":"Burger_burger-container__BH6YV"};